import Image from 'next/image';
import React from 'react';

const StrategicAiConsulting = () => {
    return (
        <div
            className="section-py dark:text-light border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="mb-[10px] dark:text-white"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Strategic AI Consulting That Transforms Business Goals Into Measurable Outcomes
                        </h2>
                        <p className="dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Unlock the full potential of Artificial Intelligence with expert AI strategy and consulting services that align technology with your business vision. We help organizations develop clear AI transformation strategies and roadmaps for enterprise-wide AI adoption. From assessing AI readiness to designing implementation plans, our consulting ensures your AI initiatives deliver measurable results.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7 mb-7">
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-safe-productive.svg"
                                        width={36}
                                        height={36}
                                        alt="safe-productive"
                                    />
                                </div>

                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Develop AI transformation strategies tailored to your business goals.
                                </p>
                            </div>
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-orchestrated-agent.svg"
                                        width={36}
                                        height={36}
                                        alt="Orchestrated agents"
                                    />
                                </div>

                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Conduct a comprehensive AI readiness evaluation and AI maturity assessment to identify gaps.
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7">
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-mcp-powered.svg"
                                        width={36}
                                        height={36}
                                        alt="MCP-powered controls"
                                    />
                                </div>
                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Design data-driven AI roadmaps and implementation strategies for maximum ROI.
                                </p>
                            </div>
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-ai-automation.svg"
                                        width={36}
                                        height={36}
                                        alt="AI automation"
                                    />
                                </div>
                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Facilitate organizational change management and AI governance frameworks for seamless adoption.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StrategicAiConsulting;
